module.exports = __webpack_public_path__ + "img/serifnew_box10.513890de.jpg";